var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close",class:_vm.classes},[_c('i',{staticClass:"fas fa-times"})])
}
var staticRenderFns = []

export { render, staticRenderFns }